import { apiRequest } from '@/utils/api-request';
import { clearNodeResults } from '@/pages/workflow/helper/clear-node-results';
import { Workflow } from '@/types/workflow-types';

export interface PublishResponse {
  message: string;
  status: string;
  api_code?: string;
  mcp_code?: string;
  api_key?: string;
  base_url?: string;
  // Set when the publish succeeded but the MCP gateway wire failed or is
  // not configured — surfaced as an informational toast.
  mcp_error?: string | null;
}

// API service for publishing workflows
export const publishWorkflow = async (
  orgId: string,
  workflowData: Workflow,
): Promise<PublishResponse> => {
  // clean node results and status
  const cleanedNodes = clearNodeResults(workflowData.nodes);

  const cleanedWorkflowData = {
    ...workflowData,
    nodes: cleanedNodes,
  };

  const response = await apiRequest<PublishResponse>({
    url: `/workflow/${orgId}/${workflowData.id}/publish-workflow`,
    method: 'POST',
    target: 'workflow',
    body: cleanedWorkflowData as unknown as Record<string, unknown>,
  });

  if (response?.detail) {
    return {
      message: response.detail || 'Failed to publish workflow',
      status: 'error',
    };
  }

  return (
    response.data || {
      message: 'Workflow published successfully',
      status: 'success',
    }
  );
};
